import React from 'react';
import { useSelector } from 'react-redux';
import BannerTopComponent from '../bannerTopComponent/BannerTopComponent';
import classes from './FinalBannerBeforeAnnouncement.module.css';

const FinalBannerBeforeAnnouncement = () => {

  const { texts } = useSelector((state) => state.translate);

  return (
    <BannerTopComponent title={texts.finalBannerTitle} colorBackground="#DEDEDE">
      <div className={classes.bannerBottomContent}>
        <p className={classes.bannerBottomContentTitle}>{texts.beforeAnnouncementText}</p>
      </div>
    </BannerTopComponent>
  );
};

export default FinalBannerBeforeAnnouncement;
